<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center align-center">
        <v-flex xs12 sm4 md4>
          <v-icon large>mdi-fingerprint</v-icon>
          <h3>Device-Level Credentials</h3>
          <p>Use fingerprint, face-unlock, USB key, etc to login</p>
        </v-flex>
        <v-flex xs12 sm8 md8>
          <v-card>
            <v-card-text>
              <p>You can register your device credentials, such as, Fingerprint, TouchID, FaceID, Windows Hello and USB keys for use to login.</p>
              <p>{{ devices > 0 ? devices : 'No' }} device<span v-if="devices > 1">s</span> enabled.
                <span class="pull-right">
                  <confirm-password @confirmed="disableAllDevices" v-if="devices > 0">
                    <v-btn x-small fab outlined color="warning" icon title="Disable all devices">
                      <v-icon>mdi-fingerprint-off</v-icon>
                    </v-btn>
                  </confirm-password>
                  <confirm-password @confirmed="deleteAllDevices">
                    <v-btn x-small fab outlined color="error" icon title="Remove all devices">
                      <v-icon>{{ icons.delete }}</v-icon>
                    </v-btn>
                  </confirm-password>
                  <confirm-password @confirmed="enableAllDevices">
                    <v-btn x-small fab outlined color="success" icon title="Enable disabled devices">
                      <v-icon>mdi-fingerprint mdi-rotate-45</v-icon>
                    </v-btn>
                  </confirm-password>
                </span>
              </p>
              <v-btn @click="registerDevice" color="black" class="white--text" :disabled="isAndroid">
                <v-icon left>mdi-fingerprint</v-icon>
                Register New Device
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  // import { useRegistration } from '@web-auth/webauthn-helper'
  const ConfirmPassword = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/ConfirmsPassword')

  export default {
    name: 'FastLogin',
    props: [
      'user'
    ],
    components: {
      ConfirmPassword,
    },
    data () {
      return {}
    },
    methods: {
      registerDevice () {
        new Larapass({
            register: '/webauthn/register',
            registerOptions: '/webauthn/register/options'
        }).register()
          .then(response => {
            swal({ title: 'Registration successful!', type: 'success', timer: 2500 })
            this.$inertia.reload()
          })
          .catch(response => alert('Something went wrong, try again!'))
      },
      deleteAllDevices () {
        swal({
          title: 'Delete all registered devices?',
          text: 'This includes disabled devices.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Delete',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.post('/webauthn/remove', {}, {
            preserveScroll: true,
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      },
      disableAllDevices () {
        swal({
          title: 'Disable all registered devices?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'orange',
          confirmButtonText:'Disable',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.post('/webauthn/disable', {}, {
            preserveScroll: true,
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      },
      enableAllDevices () {
        swal({
          title: 'Enable all disabled devices?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'green',
          confirmButtonText:'Enable',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.post('/webauthn/enable', {}, {
            preserveScroll: true,
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      }
    },
    computed: {
      devices () {
        return this.user.web_authn_credentials_count
      },
      isAndroid () {
        let agent = navigator.userAgent.toLowerCase()
        let index = agent.indexOf('android')
        return index > -1
      },
    },
  }
</script>
